(() => {
  'use strict';

  const PROVIDERS = {
    bikeleasing: {
      label: 'Bikeleasing',
      codeLabel: '8-stellige Bikeleasing Nutzer-ID',
      codeHelp: 'Bitte trage die Nutzer-ID aus dem Bikeleasing-Portal ein.',
      info: 'Bitte gib die Daten aus deinem Bikeleasing-Portal ein.',
      packages: ['Kein Paket', 'Inspektionspaket', 'Verschleißversicherung', 'Inspektion und Verschleiß', 'Eigene Auswahl']
    },
    businessbike: {
      label: 'BusinessBike',
      codeLabel: 'Quickstart E-Mail-Adresse oder Arbeitgeber-ID',
      codeHelp: 'Trage die Quickstart-Adresse oder die Arbeitgeber-ID ein.',
      info: 'Bitte gib die für BusinessBike hinterlegte Kennung ein.',
      packages: ['Kein Servicebudget', 'Basis Budget', 'Premium Budget', 'Pro Budget', 'Eigene Auswahl']
    },
    jobrad: {
      label: 'JobRad',
      codeLabel: 'E-Mail-Adresse im JobRad-Portal',
      codeHelp: 'Verwende die E-Mail-Adresse, mit der du im JobRad-Portal registriert bist.',
      info: 'Bitte verwende deine im JobRad-Portal hinterlegte E-Mail-Adresse.'
    },
    'jobrad-selbststaendige': {
      label: 'JobRad für Selbstständige',
      codeLabel: 'E-Mail-Adresse',
      codeHelp: 'Bitte gib zusätzlich das Gründungsdatum des Unternehmens an.',
      info: 'Für diese Auswahl benötigen wir zusätzlich das Gründungsdatum des Unternehmens.',
      requiresFoundingDate: true
    },
    eurorad: {
      label: 'Eurorad',
      codeLabel: 'Token oder Sofort-Token',
      codeHelp: 'Token = Rahmenleasingvertrag, Sofort-Token = Einzelleasingvertrag.',
      info: 'Bitte trage deinen Eurorad Token oder Sofort-Token ein.',
      packages: ['Basis', 'Premium', 'Premium Plus', 'Eigene Auswahl']
    },
    companybike: {
      label: 'Company Bike',
      codeLabel: 'PIN-Code',
      codeHelp: 'Trage den im Company Bike Portal erzeugten PIN-Code ein.',
      info: 'Für Company Bike ist in diesem Ablauf nur Filialabholung vorgesehen.',
      pickupOnly: true
    },
    leaseabike: {
      label: 'Lease a Bike',
      codeLabel: 'Bestellcode',
      codeHelp: 'Bitte trage den Bestellcode aus dem Lease a Bike Portal ein.',
      info: 'Bitte gib deinen Bestellcode ein.',
      packages: ['Empfehlung durchschnittl. km', 'Empfehlung hohe km-Leistung', 'Eigene Auswahl']
    },
    'deutsche-dienstrad': {
      label: 'Deutsche Dienstrad',
      codeLabel: 'E-Mail-Adresse im Kundenportal',
      codeHelp: 'Verwende die E-Mail-Adresse, die im Kundenportal hinterlegt ist.',
      info: 'Bitte verwende deine im Kundenportal hinterlegte E-Mail-Adresse.'
    },
    ride: {
      label: 'RIDE',
      codeLabel: 'Dienststellencode oder Leasing-Code',
      codeHelp: 'Bitte trage den Dienststellencode oder Leasing-Code ein.',
      info: 'Bitte gib deinen Dienststellencode oder Leasing-Code ein.'
    },
    sonstige: {
      label: 'Sonstiger Anbieter',
      codeLabel: 'Leasing-Kennung',
      codeHelp: 'Falls noch keine Kennung vorhanden ist, schreibe dies in das Nachrichtenfeld.',
      info: 'Bitte wähle diese Option, wenn dein Anbieter oben nicht dabei ist.',
      requiresOtherName: true
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-leasing-application]');
    if (!root) return;

    const form = root.querySelector('[data-leasing-form]');
    if (!form) return;

    const providerInputs = Array.from(form.querySelectorAll('[name="provider"]'));
    const providerInfo = form.querySelector('[data-provider-info]');
    const codeLabel = form.querySelector('[data-provider-code-label]');
    const codeHelp = form.querySelector('[data-provider-code-help]');
    const serviceWrapper = form.querySelector('[data-service-wrapper]');
    const serviceSelect = form.querySelector('[name="servicePackage"]');
    const customServiceWrapper = form.querySelector('[data-custom-service-wrapper]');
    const customServiceInput = form.querySelector('[name="customServicePackage"]');
    const foundingWrapper = form.querySelector('[data-founding-wrapper]');
    const foundingInput = form.querySelector('[name="companyFoundingDate"]');
    const otherProviderWrapper = form.querySelector('[data-other-provider-wrapper]');
    const otherProviderInput = form.querySelector('[name="otherProviderName"]');
    const homeDelivery = form.querySelector('[value="home"]');
    const pickupDelivery = form.querySelector('[value="pickup"]');
    const storeWrapper = form.querySelector('[data-store-wrapper]');
    const storeSelect = form.querySelector('[name="store"]');
    const submitButton = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-submit-status]');
    const cartJson = root.querySelector('[data-page-cart-json]');

    let cartState = null;
    try {
      cartState = cartJson ? JSON.parse(cartJson.textContent) : null;
    } catch (error) {
      console.error('[Leasing] Warenkorbdaten konnten nicht gelesen werden.', error);
    }

    function getSelectedProviderKey() {
      const selected = providerInputs.find((input) => input.checked);
      return selected ? selected.value : '';
    }

    function selectedProvider() {
      return PROVIDERS[getSelectedProviderKey()] || null;
    }

    function updateProviderFields() {
      const provider = selectedProvider();
      const packages = provider && Array.isArray(provider.packages) ? provider.packages : [];

      providerInfo.textContent = provider ? provider.info : 'Bitte wähle deinen Leasinganbieter aus.';
      codeLabel.textContent = provider ? `${provider.codeLabel} *` : 'Leasing-Kennung *';
      codeHelp.textContent = provider ? provider.codeHelp : '';

      serviceSelect.innerHTML = '<option value="">Bitte wählen</option>';
      packages.forEach((packageName) => {
        const option = document.createElement('option');
        option.value = packageName;
        option.textContent = packageName;
        serviceSelect.appendChild(option);
      });
      serviceWrapper.classList.toggle('leasing-hidden', packages.length === 0);
      serviceSelect.required = packages.length > 0;
      if (packages.length === 0) {
        serviceSelect.value = '';
        customServiceInput.value = '';
      }

      const requiresFoundingDate = Boolean(provider && provider.requiresFoundingDate);
      foundingWrapper.classList.toggle('leasing-hidden', !requiresFoundingDate);
      foundingInput.required = requiresFoundingDate;
      if (!requiresFoundingDate) foundingInput.value = '';

      const requiresOtherName = Boolean(provider && provider.requiresOtherName);
      otherProviderWrapper.classList.toggle('leasing-hidden', !requiresOtherName);
      otherProviderInput.required = requiresOtherName;
      if (!requiresOtherName) otherProviderInput.value = '';

      if (provider && provider.pickupOnly) {
        pickupDelivery.checked = true;
        homeDelivery.checked = false;
        homeDelivery.disabled = true;
      } else {
        homeDelivery.disabled = false;
      }

      updateDeliveryFields();
      updateCustomServiceField();
    }

    function updateCustomServiceField() {
      const isCustom = serviceSelect.value === 'Eigene Auswahl';
      customServiceWrapper.classList.toggle('leasing-hidden', !isCustom);
      customServiceInput.required = isCustom;
      if (!isCustom) customServiceInput.value = '';
    }

    function updateDeliveryFields() {
      const pickup = pickupDelivery.checked;
      storeWrapper.classList.toggle('leasing-hidden', !pickup);
      storeSelect.required = pickup;
      if (!pickup) storeSelect.value = '';
    }

    providerInputs.forEach((input) => input.addEventListener('change', updateProviderFields));
    serviceSelect.addEventListener('change', updateCustomServiceField);
    form.querySelectorAll('[name="deliveryMethod"]').forEach((input) => input.addEventListener('change', updateDeliveryFields));

    updateProviderFields();
    updateDeliveryFields();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      status.className = 'leasing-submit-status';
      status.textContent = '';

      if (!form.reportValidity()) return;

      if (!cartState || !cartState.hasBike || !Array.isArray(cartState.items) || cartState.items.length === 0) {
        showError('Der Warenkorb enthält kein leasingfähiges Fahrrad. Bitte gehe zurück zum Warenkorb.');
        return;
      }

      const workerBase = (root.dataset.workerUrl || '').trim().replace(/\/$/, '');
      if (!workerBase) {
        showError('Die Leasing-Schnittstelle ist noch nicht eingerichtet. Bitte kontaktiere uns telefonisch oder per E-Mail.');
        return;
      }

      const formData = new FormData(form);
      const payload = Object.fromEntries(formData.entries());
      payload.items = cartState.items.map((item) => ({
        variantId: String(item.variantId),
        quantity: Number(item.quantity),
        properties: item.properties || {}
      }));
      payload.cartToken = cartState.token || '';
      payload.cartTotal = Number(cartState.totalPrice || 0);
      payload.turnstileToken = formData.get('cf-turnstile-response') || '';

      try {
        const cartResponse = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (cartResponse.ok) {
          const liveCart = await cartResponse.json();
          payload.discountCodes = Array.isArray(liveCart.discount_codes)
            ? liveCart.discount_codes.map((entry) => entry.code || entry).filter(Boolean)
            : [];
        }
      } catch (error) {
        payload.discountCodes = [];
      }

      submitButton.disabled = true;
      submitButton.textContent = 'Anfrage wird erstellt …';
      status.textContent = 'Bitte schließe dieses Fenster nicht.';

      const endpoint = workerBase.endsWith('/create-draft-order')
        ? workerBase
        : `${workerBase}/create-draft-order`;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || !result.ok) {
          throw new Error(result.message || 'Die Leasing-Anfrage konnte nicht erstellt werden.');
        }

        if (root.dataset.clearCart === 'true') {
          await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}cart/clear.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: '{}'
          });
        }

        form.hidden = true;
        const success = root.querySelector('[data-leasing-success]');
        const reference = success.querySelector('[data-draft-reference]');
        reference.textContent = result.reference || 'erstellt';
        success.hidden = false;
        success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        showError(error.message || 'Es ist ein unerwarteter Fehler aufgetreten.');
        submitButton.disabled = false;
        submitButton.textContent = 'Leasing-Anfrage übermitteln';

        if (window.turnstile && typeof window.turnstile.reset === 'function') {
          window.turnstile.reset();
        }
      }
    });

    function showError(message) {
      status.className = 'leasing-submit-status leasing-alert leasing-alert--error';
      status.textContent = message;
      status.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
})();
